import { Component, OnInit, ViewChild, ElementRef, HostListener, Inject } from '@angular/core';
import {Store} from '@ngrx/store';
import { DOCUMENT } from '@angular/platform-browser';
import { MainState } from '@nw/ui-core-shared/store/main.store';
import {AppUiActions} from '@nw/ui-core-shared/store/actions';
import { UtilityService } from '@nw/ui-core-shared/services/utility.service';

@Component({
  selector: 'nw-media-detector',
  templateUrl: './media-detector.component.html',
  styleUrls: ['./media-detector.component.scss']
})

export class MediaDetectorComponent implements OnInit {
  @ViewChild('detector') detector: ElementRef;
  screenSize = '';
  curOffset = 0;
  offset = 0;
  curIsFixedHeader: any;
  curIsScrollingUp: any;
  scrollingSpeed = 6;


  constructor(private store: Store<MainState>,
              private appUiActions: AppUiActions,
              @Inject(DOCUMENT) private document: Document,
              @Inject('windowObject') private window: any,
              private utilityService: UtilityService) {
  }

  ngOnInit() {
    this.onResize();

    this.store.select(state => state.appUiState).subscribe(state => {
        this.curIsFixedHeader = state.isFixedHeader;
        this.curIsScrollingUp = state.isScrollingUp;
    });

  }


  onResize() {
    if (this.screenSize !== this.window.getComputedStyle(this.detector.nativeElement)['font-family']) {
      this.screenSize = this.window.getComputedStyle(this.detector.nativeElement)['font-family'];
      console.log(this.screenSize)
      this.store.dispatch(this.appUiActions.onScreenResize(this.screenSize));
      this.store.dispatch(this.appUiActions.setMobileDevice(this.utilityService.isMobileDevice()));
      this.store.dispatch(this.appUiActions.setiOSDevice(this.utilityService.isiOSDevice()));
    }
  }



  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    this.offset = this.window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    this.getScrollingDirection();
    this.setFixedHeader();

    this.curOffset = this.offset;
  }


  getScrollingDirection() {
    // commenting out for future references

    // if ( (this.offset - this.curOffset > this.scrollingSpeed && this.curIsScrollingUp) || !this.curIsFixedHeader) {
    //   this.store.dispatch(this.appUiActions.setWindowScrollingDirection(false));
    // } else if (this.offset - this.curOffset < (0 - this.scrollingSpeed) && !this.curIsScrollingUp) {
    //   this.store.dispatch(this.appUiActions.setWindowScrollingDirection(true));
    // }
    if (this.window.pageYOffset > 150) {
      this.store.dispatch(this.appUiActions.setWindowScrollingDirection(true));
    } else {
      this.store.dispatch(this.appUiActions.setWindowScrollingDirection(false));
    }
  }


  setFixedHeader() {
    const headerHeight = ( this.screenSize === 'lg' || this.screenSize === 'xl') ? 80 : 10;
    const isFixHeader = this.offset > headerHeight;

    if ( this.curIsFixedHeader !== isFixHeader ) {
      this.store.dispatch(this.appUiActions.setFixedHeader(isFixHeader));
    }

  }

}



// WEBPACK FOOTER //
// ./src/main/angular/app/media-detector/media-detector.component.ts